import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'
import { authApi } from 'shared/api/auth'

import { SetPasswordRequest, SetPasswordResponse } from './setPassword.types'

export const setPassword = async (data: SetPasswordRequest) => {
  const response = await authApi.post<SetPasswordResponse>(
    '/innos/set-password',
    data
  )
  return response.data
}

export const useSetPasswordMutation = (
  options?: ExtendableMutationOptions<SetPasswordResponse, SetPasswordRequest>
) => {
  return useMutation({
    mutationFn: setPassword,
    ...options
  })
}
